export default "<app-message-list></app-message-list>\r\n";